import styled from 'styled-components';
import { renderStyledElementStyles, devices } from '../../helpers';

export const sectionStyles = `
   :nth-child(even) {
    background-color: #ffffff;
  }

  :nth-child(odd) {
    background-color: #f5f5f5;
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.siteBuilderModules.ticketsModule)}
`;

export const ModuleHeading = styled.div`
  :not(:first-child) {
    margin-top: 40px;
  }
`;

export const Columns = styled.div`
  margin-bottom: 10px;
  @media (min-width: ${devices.breakpoints.tablet}) {
    :not(:first-child) {
      margin-top: 40px;
    }
  }
`;

export const CTAWrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.ctaWrapper)}

  a {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements.callToAction,
      )}
  }

  @media (min-width: ${devices.breakpoints.tablet}) {
    display: flex;
    justify-content: flex-end;
    margin: 0;
  }
`;
